@if (totalItems > 0) {
  <div class="pager-container flex-v-center">
    <div class="paged-items flex-v-center ellipsis-cut" [ngClass]="{'showAsLast': isLastElement && exceededViewport}">
      @for (item of itemsArray; track trackByIdx(idx); let idx = $index) {
        <span
          class="item"
          [ngClass]="{ 'selected': (currentIndex === idx) }"
          >&nbsp;</span
          >
        }
      </div>
      @if (showCount) {
        <div class="items-count">
          <span class="count-text">{{ currentIndex + 1 }}/{{ totalItems }}</span>
        </div>
      }
    </div>
  }
